import { useEntities } from '../../../domains/entities/entity.service';
import { EntityTableNestedContainer } from './entity-table.nested.container';
import { IAdminProps, IPersonalCompanyProps } from '../../../_core/core.types';
import { ITableModeConfig } from '../../../_core/table/table.types';

interface IEntityTableContainer extends IAdminProps, IPersonalCompanyProps {
  modeConfig?: ITableModeConfig;
}

export const EntityTableContainer: React.FC<IEntityTableContainer> = (props) => {
  const { entities, loading } = useEntities();

  return (
    <EntityTableNestedContainer {...props} entities={entities} loading={!entities || (!entities.length && loading)} />
  );
};
